import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import { Teamleader } from "./teamleaderSlice";
const employeeApi = factory.get("employee");
const approvalsApi = factory.get("approvals");
const projectsApi = factory.get("projects");
const profileApi = factory.get("profile");
const salaryApi = factory.get("manage_salary");

const initialState = {
  employee: {
    loading: false,
    form: {
      id: "",
      roles: {},
      full_name: "",
      first_name: "",
      birth_date: new Date().toISOString().split("T")[0],
      mother_name: "",
      spouse_name: "",
      province: {
        id: 1,
        name: "بغداد",
      },
      id_type: "",
      id_no: "",
      city: "",
      district: "",
      street: "",
      home: "",
      phone_no1: "",
      phone_no2: "",
      email: "",
      password: "",
      fingerprint_id: "",
      job_title_histories: [],
      projects: [],
      job_title: {
        id: "",
        name: "",
        department_id: "",
        department_name: "",
      },
      attachments: [],
      temp_attachments: [],
      degree: "",
      collage: "",
      field: "",
      gender: "",
      contacts: [
        {
          name: "",
          phone: "",
        },
      ],
      release_date: null,
      rejoin_date: null,
      marital_status: "",
      hired_date: new Date().toISOString().split("T")[0],
      start_time: dayjs(dayjs(), "HH:00:00"),
      end_time: dayjs(dayjs(), "HH:00:00"),
      day_off: "Friday",
      active: true,
      has_ticket: false,
      is_remotely: false,
      salary: 0,
      social: 0,
      sim_card: 0,
      is_dollar: "false",
      work_location: "",
      promote: {
        job_title: null,
        start_date: new Date().toISOString().split("T")[0],
      },
      extension_number: "",
    },
    finance_dialog_emp_id: null,
    finance_dialog: false,
    errors: [],
  },
  employees: {
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 15,
      search: "",
      department_id: null,
      is_active: "1",
      is_remotely: "all",
      page: 0,
      fingerprint_id: "",
      order_by: "0", // 0 sort by created_at , 1 by job_title
    },
  },
  user_logs: {
    loading: false,
    data: [],
    total: 0,
  },
  approvals: {
    dialog: false,
    loading: false,
    form: {
      user_id: "",
      approval_users: [],
    },
    user: {},
    data: [],
  },
  projectsList: {
    data: [
      {
        id: 1,
        name: "hr",
      },
      {
        id: 2,
        name: "ticket",
      },
      {
        id: 3,
        name: "ftth",
      },
    ],
  },
  over_time: {
    loading: false,
    dialog: false,
    form: {
      user_id: "",
      name: "",
      added_over_time: 0,
    },
    data: [],
  },
  daily_remote: {
    loading: false,
    dialog: false,
    form: {
      user_id: "",
      name: "",
      days: [],
    },
  },
  salary_history: {
    loading: false,
    data: [],
  },
  activity_log: {
    dialog: false,
    loading: false,
    data: [],
    total: 0,
    filters: {
      skip: 0,
      take: 15,
      page: 0,
      model: "",
      id: "",
    },
  },
};

export const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setFinanceDialog: (state, { payload }) => {
      if (payload) {
        state.employee.finance_dialog_emp_id = payload;
      } else {
        state.employee.finance_dialog_emp_id = null;
      }
      state.employee.finance_dialog = !state.employee.finance_dialog;
    },
    setDataTable: (state, { payload }) => {
      state.employees.data = payload.data.data;
      state.employees.total = payload.data.total;
    },
    setUserLogTable: (state, { payload }) => {
      state.user_logs.data = payload.data.data;
      state.user_logs.total = payload.data.total;
    },
    setEmployee: (state, { payload }) => {
      Object.keys(state.employee.form).forEach((key) => {
        switch (key) {
          case "start_time":
            state.employee.form[key] = dayjs(payload[key], "HH:mm:00");
            break;
          case "end_time":
            state.employee.form[key] = dayjs(payload[key], "HH:mm:00");
            break;
          case "contacts":
            state.employee.form[key] = payload[key];
            break;
          case "release_date":
            state.employee.form[key] = null;
            break;
          case "projects":
            if (payload[key]) {
              if (payload[key].length > 0) {
                payload[key].forEach((item) => {
                  state.employee.form[key].push(item.id);
                });
              } else {
                state.employee.form[key] = [];
              }
            }
            break;
          // case "rejoin_date":
          //   state.employee.form[key] = payload[key]
          //     ? dayjs(payload[key], "YYYY-MM-DD")
          //     : null;
          //   break;
          case "job_title":
            if (payload.department) {
              state.employee.form[key] = payload[key];
              state.employee.form[key].department_name =
                payload.department?.name;
            } else {
              state.employee.form.job_title = {
                id: "",
                name: "",
                department_id: "",
                department_name: "",
              };
            }
            break;
          case "roles":
            state.employee.form[key] = payload[key][0];
            break;
          case "is_dollar":
            state.employee.form[key] = payload[key] ? "true" : "false";
            break;
          default:
            state.employee.form.rejoin_date = null;
            state.employee.form.profile_pic = payload?.profile_pic || "";
            state.employee.form[key] = payload[key] == null ? "" : payload[key];
            break;
        }
      });
    },
    setContacts: (state, { payload }) => {
      state.employee.form.contacts.push({
        name: payload.name,
        phone: payload.phone,
      });
    },
    setErrors: (state, { payload }) => {
      state.employee.errors = payload;
    },
    resetForm: (state) => {
      state.employee.form = initialState.employee.form;
      state.employee.errors = [];
    },
    resetApprovalForm: (state) => {
      state.approvals = initialState.approvals;
    },
    setApprovalDialog: (state, { payload }) => {
      state.approvals.dialog = !state.approvals.dialog;
      if (payload) {
        state.approvals.form.user_id = payload.id;
        state.approvals.user = payload;
      } else {
        state.approvals.form.user_id = "";
        state.approvals.user = {};
      }
    },
    setApprovals: (state, { payload }) => {
      if (payload.length > 0) {
        payload.map((item) => {
          state.approvals.form.approval_users.push(item);
        });
      }
    },
    setFilters: (state, { payload }) => {
      state.employees.filters = {
        ...state.employees.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.employees.filters = initialState.employees.filters;
    },
    deeleteUserApproval: (state, { payload }) => {
      state.approvals.form.approval_users =
        state.approvals.form.approval_users.filter(
          (item) => item.id !== payload
        );
    },
    setOverTimeDialog: (state, { payload }) => {
      state.over_time.dialog = !state.over_time.dialog;
      if (payload?.id) {
        state.over_time.form.user_id = payload.id;
        state.over_time.form.name = payload.name;
      } else {
        state.over_time.form.user_id = "";
        state.over_time.form.name = "";
      }
    },
    setOverTimeDialogTable: (state, { payload }) => {
      state.over_time.data = payload;
    },
    setDailyRemoteDialog: (state, { payload }) => {
      state.daily_remote.dialog = !state.daily_remote.dialog;
      if (payload?.id) {
        state.daily_remote.form.user_id = payload.id;
        state.daily_remote.form.name = payload.name;
      } else {
        state.daily_remote.form = initialState.daily_remote.form;
      }
    },
    setSalaryHistory: (state, { payload }) => {
      state.salary_history.data = payload;
    },
    setActivityLogDialog: (state, { payload }) => {
      if (payload) {
        state.activity_log.filters = {
          ...state.activity_log.filters,
          ...payload,
        };
      }
      state.activity_log.dialog = !state.activity_log.dialog;
    },
    setActivityLogData: (state, { payload }) => {
      state.activity_log.data = payload.data || [];
      state.activity_log.total = payload.total || [];
    },
    setActivityLogFilters: (state, { payload }) => {
      state.activity_log.filters = {
        ...state.activity_log.filters,
        ...payload,
      };
    },
  },
});

export const {
  setLoading,
  setDataTable,
  setUserLogTable,
  setErrors,
  setEmployee,
  setContacts,
  resetForm,
  setApprovals,
  setApprovalDialog,
  resetApprovalForm,
  resetFilters,
  setFilters,
  deeleteUserApproval,
  setOverTimeDialog,
  setOverTimeDialogTable,
  setDailyRemoteDialog,
  setFinanceDialog,
  setSalaryHistory,
  setActivityLogDialog,
  setActivityLogData,
  setActivityLogFilters,
} = employeeSlice.actions;

export default employeeSlice.reducer;

const toNumber = (value) => {
  return typeof value === "number" ? value : parseInt(value.replace(/,/g, ""));
};
//axios
const getAll = () => async (dispatch, getState) => {
  try {
    const filters = getState().employee.employees.filters;
    let _filters = {
      ...filters,
      department_id: filters.department_id ? filters.department_id.id : null,
    };
    dispatch(setLoading("employees"));
    const res = await employeeApi.getAll(_filters);
    dispatch(setDataTable(res));
    dispatch(setLoading("employees"));
  } catch (err) {
    dispatch(setLoading("employees"));
    throw new Error(err);
  }
};
const toExcel = () => async (dispatch, getState) => {
  try {
    const filters = getState().employee.employees.filters;
    dispatch(setLoading("employees"));
    const res = await employeeApi.exportToExcel({
      ...filters,
      department_id: filters.department_id ? filters.department_id.id : null,
    });
    let url = window.URL.createObjectURL(res.data);
    let a = document.createElement("a");
    a.href = url;
    a.download = "employees.xlsx";
    a.click();
    dispatch(setLoading("employees"));
  } catch (err) {
    dispatch(setLoading("employees"));
    throw new Error(err);
  }
};
const deleteById = (data) => async (dispatch) => {
  try {
    const res = await employeeApi.delete(data.user_id);
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    dispatch(
      getAll({
        search: data.search,
        skip: 0,
        take: 0,
      })
    );
    return {
      success: true,
    };
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getById = (id) => async (dispatch) => {
  try {
    dispatch(resetForm());
    dispatch(setLoading("employee"));
    const res = await employeeApi.getById(id);
    dispatch(setEmployee(res.data.data[0]));
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const create = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));

    let formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (key) {
        case "job_title":
          formData.append("job_title_id", data[key].id);
          break;
        case "attachments":
          break;
        case "profile_pic":
          break;
        case "release_date":
          break;
        case "rejoin_date":
          break;
        case "province":
          formData.append("province_id", data[key].id);
          break;
        case "start_time":
          formData.append(
            "start_time",
            dayjs(data[key], "HH:00:00").format("HH:00:00")
          );
          break;
        case "end_time":
          formData.append(
            "end_time",
            dayjs(data[key], "HH:00:00").format("HH:00:00")
          );
          break;
        case "is_remotely":
          formData.append("is_remotely", data[key] ? 1 : 0);
          break;
        case "temp_attachments":
          data[key].forEach((item, index) => {
            formData.append(`attachments[${index}]`, item);
          });
          break;
        case "is_dollar":
          formData.append("is_dollar", data[key] === "true" ? 1 : 0);
          break;
        case "sim_card":
          formData.append("sim_card", data[key] ? data[key] : 0);
          break;
        case "social":
          formData.append("social", data[key] ? toNumber(data[key]) : 0);
          break;
        case "salary":
          formData.append("salary", data[key] ? toNumber(data[key]) : 0);
          break;
        case "contacts":
          if (data[key].length > 0) {
            data[key].forEach((item, index) => {
              formData.append(`contacts[${index}]`, JSON.stringify(item));
            });
          } else {
            formData.append(`contacts`, JSON.stringify([]));
          }
          break;
        default:
          formData.append(key, data[key]);
          break;
      }
    });

    const res = await employeeApi.create(formData);

    dispatch(resetForm());
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(setErrors(err.response.data.errors));
    dispatch(
      showNotification({
        message: "حصل خطأ ما",
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    let formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (key) {
        case "job_title":
          formData.append("job_title_id", data[key].id);
          break;
        case "password":
          break;
        case "attachments":
          break;
        case "profile_pic":
          break;
        case "release_date":
          break;
        case "rejoin_date":
          break;
        case "province":
          formData.append("province_id", data[key].id);
          break;
        case "start_time":
          formData.append("start_time", dayjs(data[key]).format("HH:mm:ss"));
          break;
        case "end_time":
          formData.append("end_time", dayjs(data[key]).format("HH:mm:ss"));
          break;
        case "is_remotely":
          formData.append("is_remotely", data[key] ? 1 : 0);
          break;
        case "is_dollar":
          formData.append("is_dollar", data[key] === "true" ? 1 : 0);
          break;
        case "sim_card":
          formData.append("sim_card", data[key] ? data[key] : 0);
          break;
        case "social":
          formData.append("social", data[key] ? toNumber(data[key]) : 0);
          break;
        case "salary":
          formData.append("salary", data[key] ? toNumber(data[key]) : 0);
          break;
        case "temp_attachments":
          if (data[key].length > 0)
            data[key].forEach((item, index) => {
              formData.append(`attachments[${index}]`, item);
            });
          break;
        case "contacts":
          if (data[key].length > 0) {
            data[key].forEach((item, index) => {
              formData.append(`contacts[${index}]`, JSON.stringify(item));
            });
          } else {
            formData.append(`contacts`, JSON.stringify([]));
          }
          break;
        default:
          formData.append(key, data[key]);
          break;
      }
    });

    formData.append("_method", "PUT");

    const res = await employeeApi.update(data.id, formData);

    dispatch(setErrors([]));
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    dispatch(setLoading("employee"));
    dispatch(getById(data.id));
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(setErrors(err.response.data.errors));
    dispatch(
      showNotification({
        message: "حصل خطأ ما",
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const updateSalary = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));

    const res = await employeeApi.updateSalary({
      id: data.id,
      salary: data.salary ? toNumber(data.salary) : 0,
      social: data.social ? toNumber(data.social) : 0,
      sim_card: data.sim_card ? data.sim_card : 0,
      is_dollar: data.is_dollar === "true" ? 1 : 0,
    });
    dispatch(setErrors([]));
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    dispatch(setLoading("employee"));
    dispatch(setFinanceDialog());
    dispatch(getAll());
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(setErrors(err.response.data.errors));
    dispatch(
      showNotification({
        message: "حصل خطأ ما",
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const changePassword = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));

    let res = null;

    res =
      data.type === "Employee"
        ? await employeeApi.changePassword(data)
        : await employeeApi.changePasswordProfile(data);

    dispatch(setErrors([]));
    dispatch(
      showNotification({
        message: res.data.message,
        type: "success",
      })
    );
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const remotly = (filters, data) => async (dispatch) => {
  try {
    dispatch(setLoading("employees"));
    await employeeApi.makeItRemotely({
      is_remotely: data.is_remotely,
      is_all: false,
      users: data.users,
    });
    dispatch(setLoading("employees"));
    // await employeeApi.makeItRemotely(formData)
    dispatch(
      getAll({
        ...filters,
      })
    );
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employees"));
    throw new Error(err);
  }
};
const getApprovalsById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("approvals"));
    const res = await approvalsApi.getById(id);
    dispatch(setApprovals(res.data.data));
    dispatch(setLoading("approvals"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("approvals"));
    throw new Error(err);
  }
};
const assignApprovals = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("approvals"));
    let approval_users = [];
    await data.approval_users.forEach((item) => {
      approval_users.push(item.id);
    });
    await approvalsApi.update({
      approval_users: approval_users,
      user_id: data.user_id,
    });
    // if (data.is_add) {
    //     await approvalsApi.create({
    //         approval_users: approval_users,
    //         user_id: data.user_id
    //     })
    // } else {
    //     await approvalsApi.update({
    //         approval_users: approval_users,
    //         user_id: data.user_id
    //     })
    // }
    dispatch(
      showNotification({
        message: "تم تعديل الموافقات بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("approvals"));
    dispatch(setApprovalDialog());
    dispatch(getAll());
    return {
      success: true,
    };
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("approvals"));
    throw new Error(err);
  }
};
const toggleActiveDeactive = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    await employeeApi.toggleActiveDeactive({
      user_id: data.user_id,
    });
    dispatch(
      showNotification({
        message: "تم تعديل الحالة بنجاح",
        type: "success",
      })
    );
    dispatch(
      getAll({
        ...data.filters,
      })
    );
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const getLogData = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("user_logs"));
    const res = await employeeApi.userlog(id);
    dispatch(setUserLogTable(res));
    dispatch(setLoading("user_logs"));
  } catch (err) {
    dispatch(setLoading("user_logs"));
    throw new Error(err);
  }
};
const release = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    await employeeApi.userRelease(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(getLogData(data.user_id));
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const rejoin = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    await employeeApi.userRejoin(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(getLogData(data.user_id));
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const promote = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    await employeeApi.promote(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(getLogData(data.user_id));
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const shiftByOneHour = (data) => async (dispatch, getState) => {
  try {
    const filters = getState().employee.employees.filters;
    dispatch(setLoading("employee"));
    await employeeApi.shiftByOneHour(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(
      getAll({
        ...filters,
      })
    );
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const updateProjects = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    await projectsApi.updateProjects(data);
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(getLogData(data.user_id));
    dispatch(setLoading("employee"));
  } catch (err) {
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    dispatch(setLoading("employee"));
    throw new Error(err);
  }
};
const overTime = (data, type) => async (dispatch) => {
  try {
    dispatch(setLoading("over_time"));
    await employeeApi.overTime({
      ...data,
      added_over_time: parseInt(data.added_over_time),
    });
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("over_time"));
    if (type === "employee") {
      dispatch(getAll());
    } else {
      dispatch(Teamleader.getAll());
    }
    dispatch(setOverTimeDialog());
  } catch (err) {
    dispatch(setLoading("over_time"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const addDailyRemote = (data) => async (dispatch, getState) => {
  try {
    const { user_id } = getState().employee.daily_remote.form;
    dispatch(setLoading("daily_remote"));
    await employeeApi.addRemotelyDays({
      user_id: user_id,
      ...data,
    });
    dispatch(
      showNotification({
        message: "تمت العملية بنجاح",
        type: "success",
      })
    );
    dispatch(setLoading("daily_remote"));
    dispatch(getAll());
    dispatch(setDailyRemoteDialog());
  } catch (err) {
    dispatch(setLoading("daily_remote"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getDailyRemote = () => async (dispatch, getState) => {
  try {
    const { user_id } = getState().employee.daily_remote.form;
    dispatch(setLoading("daily_remote"));
    const res = await employeeApi.getRemotelyDaysById(user_id);
    dispatch(setLoading("daily_remote"));
    return res;
  } catch (err) {
    dispatch(setLoading("daily_remote"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const deleteAttachment = (attachment_id) => async (dispatch, getState) => {
  try {
    const { id } = getState().employee.employee.form;
    dispatch(setLoading("employee"));
    const res = await profileApi.deleteAttachment(attachment_id);
    dispatch(setLoading("employee"));
    dispatch(
      showNotification({
        message: "تم حذف المرفق بنجاح",
        type: "success",
      })
    );
    dispatch(getById(id));
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const getOverTimeData = () => async (dispatch, getState) => {
  try {
    const { user_id } = getState().employee.over_time.form;

    dispatch(setLoading("over_time"));
    const res = await employeeApi.getOverTimeData(user_id);
    dispatch(setOverTimeDialogTable(res.data.data));
    dispatch(setLoading("over_time"));
  } catch (err) {
    dispatch(setLoading("over_time"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getSalaryHistoryById = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("salary_history"));
    const res = await salaryApi.getAll({
      user_id: id,
    });
    dispatch(setSalaryHistory(res.data.data));
    dispatch(setLoading("salary_history"));
  } catch (err) {
    dispatch(setLoading("salary_history"));
    throw new Error(err);
  }
};

const getActivityLog = () => async (dispatch, getState) => {
  try {
    const { filters } = getState().employee.activity_log;
    dispatch(setLoading("activity_log"));
    const res = await employeeApi.getActivityLog(filters);
    dispatch(setActivityLogData(res.data));
    dispatch(setLoading("activity_log"));
  } catch (err) {
    dispatch(setLoading("activity_log"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const getFingerPrintId = () => async (dispatch) => {
  try {
    const res = await employeeApi.getFingerPrintId();
    return res.data.data;
  } catch (err) {
    throw new Error(err);
  }
};

const sendEmail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading("employee"));
    const res = await employeeApi.sendEmail(id);
    dispatch(setLoading("employee"));
    return res;
  } catch (err) {
    dispatch(setLoading("employee"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Employee = {
  create,
  deleteById,
  getAll,
  toExcel,
  getById,
  changePassword,
  update,
  remotly,
  getApprovalsById,
  assignApprovals,
  toggleActiveDeactive,
  release,
  rejoin,
  promote,
  getLogData,
  shiftByOneHour,
  updateProjects,
  overTime,
  addDailyRemote,
  getDailyRemote,
  deleteAttachment,
  getOverTimeData,
  updateSalary,
  getSalaryHistoryById,
  getActivityLog,
  getFingerPrintId,
  sendEmail,
};
